import { render, staticRenderFns } from "./AppDetailTab2.vue?vue&type=template&id=5228a215&scoped=true";
import script from "./AppDetailTab2.vue?vue&type=script&lang=js";
export * from "./AppDetailTab2.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab2.vue?vue&type=style&index=0&id=5228a215&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "5228a215", null);
export default component.exports;